import { enUS } from 'date-fns/locale';
export function getNavigatorLocaleKey(key) {
    const [language, regional] = key.split('-');
    return Boolean(regional) ? `${language}${regional}` : language;
}
export function getLocale() {
    if (!Boolean(window['__localeId__'])) {
        window['__localeId__'] = 'enUS';
    }
    return window['__localeId__'];
}
export function getLocales() {
    if (!Boolean(window['__locales__'])) {
        window['__locales__'] = { enUS };
    }
    return window['__locales__'];
}
export function setLocale(key) {
    window['__localeId__'] = key;
}
export function setLocales(locales) {
    window['__locales__'] = locales;
}
export function getCurrentLocale() {
    var _a;
    return (_a = getLocales()[getLocale()]) !== null && _a !== void 0 ? _a : enUS;
}
